declare namespace $ {

	type $shm_dashboard_app_dashboard_list_head__title_shm_dashboard_app_dashboard_list_1 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app_dashboard_list['title'] >
		,
		ReturnType< $shm_dashboard_app_dashboard_list_head['title'] >
	>
	type $shm_dashboard_app_dashboard_list_head__filter_shm_dashboard_app_dashboard_list_2 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app_dashboard_list['filter'] >
		,
		ReturnType< $shm_dashboard_app_dashboard_list_head['filter'] >
	>
	type $shm_dashboard_app_dashboard_list_head__search_showed_shm_dashboard_app_dashboard_list_3 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app_dashboard_list['search_showed'] >
		,
		ReturnType< $shm_dashboard_app_dashboard_list_head['search_showed'] >
	>
	type $mol_link__arg_shm_dashboard_app_dashboard_list_4 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app_dashboard_list['dashboard_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__current_shm_dashboard_app_dashboard_list_5 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app_dashboard_list['dashboard_current'] >
		,
		ReturnType< $mol_link['current'] >
	>
	type $mol_link__title_shm_dashboard_app_dashboard_list_6 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app_dashboard_list['dashboard_title'] >
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_list__rows_shm_dashboard_app_dashboard_list_7 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app_dashboard_list['dashboard_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	export class $shm_dashboard_app_dashboard_list extends $mol_page {
		filter( next?: string ): string
		search_showed( ): boolean
		List_head( ): $shm_dashboard_app_dashboard_list_head
		dashboard_arg( id: any): Record<string, any>
		dashboard_current( id: any): boolean
		dashboard_title( id: any): string
		Dashboard_link( id: any): $mol_link
		dashboard_rows( ): readonly($mol_view)[]
		Dashboard_menu( ): $mol_list
		dashboard_id( next?: string ): string
		dashboard_model( ): $shm_ba_dashboard_model | null
		dashboard_rows_all( ): readonly($mol_view)[]
		title( ): string
		head( ): readonly(any)[]
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=list.web.view.tree.d.ts.map